import { render } from "./ThePatientDocument.vue?vue&type=template&id=d93d97f8&scoped=true&ts=true"
import script from "./ThePatientDocument.vue?vue&type=script&lang=ts"
export * from "./ThePatientDocument.vue?vue&type=script&lang=ts"

import "./ThePatientDocument.vue?vue&type=style&index=0&id=d93d97f8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d93d97f8"]])

export default __exports__